import VehicleGroup from './VehicleGroup'

export default VehicleGroup
